var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-editions",class:{
    'tw-py-6': true,
    'md:tw-flex md:tw--mx-2 md:tw-justify-center': true,
  }},_vm._l((_vm.plugin.editions),function(edition,key){return _c('plugin-edition',{key:key,staticClass:"md:tw-flex-1 md:tw-mx-2 md:tw-max-w-xs",attrs:{"plugin":_vm.plugin,"edition":edition}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }